module.exports = {
	"id": "/event_test",
	"type": "object",
	"properties": {
		"eventId": {
			"type": "integer",
			"required": true
		},
		"tournamentId": {
			"type": "integer",
			"required": true
		},
		"sportId": {
			"type": "integer",
			"required": true
		},
		"minutes": {
			"type": "integer",
			"required": false
		}
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ../src/config/message_schemas/triggers/event_test.json
 ** module id = 1830
 ** module chunks = 0
 **/